import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, EyeOff, Save } from 'lucide-react';
import { API } from '../../contexts/AuthContext';
import { FileUpload } from '../../components/admin/FileUpload';

export default function PopupAdmin() {
  const [popup, setPopup] = useState({
    enabled: false, title: '', description: '', image_url: '', video_url: '',
    button_text: '', button_url: '', popup_type: 'announcement'
  });
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState('');

  const token = localStorage.getItem('idsea_token');
  const headers = { Authorization: `Bearer ${token}` };
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  useEffect(() => {
    axios.get(`${API}/admin/popup`, { headers }).then(r => {
      if (r.data && Object.keys(r.data).length > 0) setPopup(r.data);
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/popup`, popup, { headers });
      showToast('Popup settings saved!');
    } catch { showToast('Save failed'); }
    setSaving(false);
  };

  const update = (key, val) => setPopup(prev => ({ ...prev, [key]: val }));

  return (
    <div>
      {toast && <div className="toast-success" data-testid="toast">{toast}</div>}
      <div className="page-header">
        <h1 className="page-title" data-testid="popup-title">Homepage Popup</h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => update('enabled', !popup.enabled)}
            className={popup.enabled ? 'btn-primary' : 'btn-secondary'}
            data-testid="popup-toggle"
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {popup.enabled ? <><Eye size={14} /> Active</> : <><EyeOff size={14} /> Inactive</>}
          </button>
          <button onClick={handleSave} className="btn-primary" disabled={saving} data-testid="save-popup-btn">
            <Save size={14} /> {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>

      <div className="admin-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', padding: '12px 16px', background: popup.enabled ? '#f0fdf4' : '#fef2f2', borderRadius: '10px', border: `1px solid ${popup.enabled ? '#bbf7d0' : '#fecaca'}` }}>
          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: popup.enabled ? '#22c55e' : '#ef4444' }} />
          <span style={{ fontSize: '13px', fontWeight: 600, color: popup.enabled ? '#166534' : '#991b1b' }}>
            {popup.enabled ? 'Popup is ACTIVE — visitors will see it on the homepage' : 'Popup is INACTIVE — visitors will not see it'}
          </span>
        </div>

        <div className="form-group">
          <label className="form-label">Popup Type</label>
          <select value={popup.popup_type || 'announcement'} onChange={e => update('popup_type', e.target.value)} className="form-select" data-testid="popup-type">
            <option value="announcement">Announcement</option>
            <option value="event">Event Promotion</option>
            <option value="news">News</option>
            <option value="custom">Custom</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Title</label>
          <input value={popup.title || ''} onChange={e => update('title', e.target.value)} className="form-input" placeholder="Popup heading" data-testid="popup-input-title" />
        </div>

        <div className="form-group">
          <label className="form-label">Description (HTML supported)</label>
          <textarea value={popup.description || ''} onChange={e => update('description', e.target.value)} className="form-textarea" rows={5} placeholder="Popup content..." data-testid="popup-description" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Image</label>
            <FileUpload accept="image/*" label="Upload Image" onUpload={(url) => update('image_url', url)} />
            {popup.image_url && (
              <div style={{ marginTop: '8px', position: 'relative', display: 'inline-block' }}>
                <img src={popup.image_url.startsWith('/api') ? `${API.replace('/api', '')}${popup.image_url}` : popup.image_url} alt="" style={{ height: '80px', borderRadius: '8px', objectFit: 'cover' }} />
                <button onClick={() => update('image_url', '')} style={{ position: 'absolute', top: '-6px', right: '-6px', width: '20px', height: '20px', borderRadius: '50%', background: '#ef4444', color: 'white', border: 'none', cursor: 'pointer', fontSize: '12px' }}>&times;</button>
              </div>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Video Embed URL (optional)</label>
            <input value={popup.video_url || ''} onChange={e => update('video_url', e.target.value)} className="form-input" placeholder="https://youtube.com/embed/..." />
            <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>YouTube or Vimeo embed URL. Image takes priority if both set.</p>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Button Text</label>
            <input value={popup.button_text || ''} onChange={e => update('button_text', e.target.value)} className="form-input" placeholder="e.g. Register Now, Learn More" data-testid="popup-btn-text" />
          </div>
          <div className="form-group">
            <label className="form-label">Button Link</label>
            <input value={popup.button_url || ''} onChange={e => update('button_url', e.target.value)} className="form-input" placeholder="/events/xyz or https://..." data-testid="popup-btn-url" />
          </div>
        </div>
      </div>
    </div>
  );
}
